/**
 * Tipos de validação e mensagens para Roadmap
 */
export const VALIDATION_TYPES = {
  MISSING_NAME: {
    type: 'missing_name',
    getMessage: (lineNumber) => `Linha ${lineNumber}: O campo 'Nome' é obrigatório e não pode estar vazio.`
  },
  MISSING_LEVEL: {
    type: 'missing_level',
    getMessage: (lineNumber, nome) => `Linha ${lineNumber}: O campo 'Nível' é obrigatório e não pode estar vazio (Nome: "${nome || 'Nome não informado'}").`
  },
  INVALID_LEVEL: {
    type: 'invalid_level',
    getMessage: (lineNumber, nivel, nome, validLevels) => `Linha ${lineNumber}: Nível "${nivel}" inválido para "${nome || 'Nome não informado'}". Use apenas: ${validLevels.join(', ')}.`
  },
  ORPHAN_SUBITEM: {
    type: 'orphan_subitem',
    getMessage: (lineNumber, nome) => `Linha ${lineNumber}: Subitem "${nome || 'Nome não informado'}" deve ter um item principal acima dele.`
  },
  MISSING_STATUS: {
    type: 'missing_status',
    getMessage: (lineNumber, nome) => `Linha ${lineNumber}: O campo 'Status' é obrigatório e não pode estar vazio (Nome: "${nome || 'Nome não informado'}").`
  },
  INVALID_STATUS: {
    type: 'invalid_status',
    getMessage: (lineNumber, status, nome) => `Linha ${lineNumber}: Status "${status}" inválido para "${nome || 'Nome não informado'}").`
  },
  MISSING_DATA_INICIO: {
    type: 'missing_data_inicio',
    getMessage: (lineNumber, nome) => `Linha ${lineNumber}: Data de Início é obrigatória para itens concluídos (Nome: "${nome || 'Nome não informado'}").`
  },
  MISSING_PREVISAO_ENTREGA: {
    type: 'missing_previsao_entrega',
    getMessage: (lineNumber, nome) => `Linha ${lineNumber}: Previsão de Entrega é obrigatória para itens concluídos (Nome: "${nome || 'Nome não informado'}").`
  },
  MISSING_DATA_CONCLUSAO: {
    type: 'missing_data_conclusao',
    getMessage: (lineNumber, nome) => `Linha ${lineNumber}: Data de Conclusão é obrigatória para itens concluídos (Nome: "${nome || 'Nome não informado'}").`
  },
  INVALID_DATA_CONCLUSAO: {
    type: 'invalid_data_conclusao',
    getMessage: (lineNumber, nome) => `Linha ${lineNumber}: Data de Conclusão deve ser maior ou igual à Data de Início (Nome: "${nome || 'Nome não informado'}").`
  },
  INVALID_DATA_INICIO_FORMAT: {
    type: 'invalid_data_inicio_format',
    getMessage: (lineNumber, nome, data) => `Linha ${lineNumber}: Data de Início com formato inválido "${data}" (Nome: "${nome || 'Nome não informado'}"). Use formato dd/mm/aaaa.`
  },
  INVALID_PREVISAO_ENTREGA_FORMAT: {
    type: 'invalid_previsao_entrega_format',
    getMessage: (lineNumber, nome, data) => `Linha ${lineNumber}: Previsão de Entrega com formato inválido "${data}" (Nome: "${nome || 'Nome não informado'}"). Use formato dd/mm/aaaa.`
  },
  INVALID_DATA_CONCLUSAO_FORMAT: {
    type: 'invalid_data_conclusao_format',
    getMessage: (lineNumber, nome, data) => `Linha ${lineNumber}: Data de Conclusão com formato inválido "${data}" (Nome: "${nome || 'Nome não informado'}"). Use formato dd/mm/aaaa.`
  }
};
